import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render Chief Executive officer section for selections tab
 */
const ChiefExecutiveOfficerSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150"
      data-testid="chief-executive-officer-section-component"
    >
      <AccordionV2
        testId="chief-executive-officer"
        className="border-x py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Best Chief Executive Officer" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 pt-4">
          <p>
            The selection for this Award goes through a three-stage process:
          </p>

          <p>
            In Stage 1, likely candidates will be identified through the
            following sources:
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>Nominations;</li>

            <li>Media reports and industry knowledge;</li>

            <li>
              Rankings of the CEO companies in the ASEAN Corporate Governance
              Scorecard and the Singapore Governance and Transparency Index;
            </li>

            <li>Performance of the CEO companies;</li>
          </ul>

          <p>
            A preliminary shortlist of candidates are developed using the
            criteria (described below).
          </p>

          <p>
            In Stage 2, additional inputs on shortlisted CEOs are obtained
            through research and discreet inquiries. A final shortlist is then
            developed for the judges in Stage 3.
          </p>

          <p>
            In Stage 3, a panel of judges will review and evaluate the
            shortlisted candidates. The judges will consider the information
            from the prior research using the criteria developed.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ChiefExecutiveOfficerSection;
